import React from 'react';
import './style.scss';
import classnames from 'classnames';
import { BUTTON_TYPE } from '@/utils/constants';

const PREFIX = 'single-button-container';

export default class SingleButton extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    // props
    text: '',
    handleClick() { },
    disabled: false,
  };

  render() {
    const {
      text,
      handleClick,
      passedRef,
      trackingname,
      trackingindex,
      trackingdata,
      className,
      disabled,
      children,
    } = this.props;

    return (
      <div
        className={classnames(PREFIX, 'single-button-wrapper', className, { disabled: disabled })}
        ref={passedRef}
        data-trackingname={trackingname}
        data-trackingindex={trackingindex}
        data-trackingdata={trackingdata}
        onClick={handleClick}
      >
        {className === getClassName(BUTTON_TYPE.ORDINARY_SELECTOR) ? (
          <div>{text}</div>
        ) : (
          <>{children ?? <span>{ text }</span>}</>
        )}
      </div>
    );
  }
}

export function getClassName(styleEnum) {
  const mapping = {
    [BUTTON_TYPE.PRIMARY]: 'primary',
    [BUTTON_TYPE.PRIMARY_DISABLED]: 'primary-disabled',
    [BUTTON_TYPE.PRIMARY_OUTLINED]: 'primary-outlined',
    [BUTTON_TYPE.SECONDARY]: 'secondary',
    [BUTTON_TYPE.SECONDARY_DISABLED]: 'secondary-disabled',
    [BUTTON_TYPE.FRAMELESS]: 'frameless',
    [BUTTON_TYPE.FRAMELESS_DISABLED]: 'frameless-disabled',
    [BUTTON_TYPE.TRADITIONAL]: 'traditional',
    [BUTTON_TYPE.TRADITIONAL_DISABLED]: 'traditional-disabled',
    [BUTTON_TYPE.ORDINARY_SELECTOR]: 'ordinary-selector',
  };

  return mapping[styleEnum];
}

// 获取按钮对应的禁用style
export function getDisabledClassName(styleEnum) {
  const mapping = {
    [BUTTON_TYPE.PRIMARY]: BUTTON_TYPE.PRIMARY_DISABLED,
    [BUTTON_TYPE.PRIMARY_OUTLINED]: BUTTON_TYPE.SECONDARY_DISABLED,
    [BUTTON_TYPE.SECONDARY]: BUTTON_TYPE.SECONDARY_DISABLED,
    [BUTTON_TYPE.FRAMELESS]: BUTTON_TYPE.FRAMELESS_DISABLED,
    [BUTTON_TYPE.TRADITIONAL]: BUTTON_TYPE.TRADITIONAL_DISABLED,
  };

  return getClassName(mapping[styleEnum] || styleEnum);
}
